import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      // eslint-disable-next-line camelcase
      visit_referral: {
         actionBar: {
            confirmAndPrint: 'Zatwierdź i drukuj',
         },
         additionalInformation: 'Dodatkowe informacje',
         analyticalExamination: {
            analyticalExamination: 'Badanie',
            analyticalExaminations: 'Badania',
            chosenExaminations: 'Wybrane badania',
            mostCommonExaminations: 'Najczęściej wybierane badania',
            noExaminationsSelected: 'Nie dodano żadnego badania do Skierowania',
            noExaminationsSelectedAdditionalText:
               'Uzupełnij nazwę badania w wyszukiwarce i wybierz jedną z podpowiedzi.',
            noFrequentAnalyticalExaminationSubText:
               'W tym miejscu pojawią się najczęściej wybierane badania podczas wszystkich zrealizowanych wizyt.',
            noFrequentAnalyticalExaminations: 'Brak najczęściej wybieranych badań',
            searchAnalyticalExaminations: 'Uzupełnij nazwę badania...',
         },
         certificateErrorOccurred: 'Wystąpił problem z certyfikatem placówki.',
         choose: 'Wybierz',
         choosePatientNFZDepartment: 'Wybierz oddział NFZ, w którym ubezpieczony jest pacjent',
         cito: 'Pilne',
         diagnosticLaboratoryType: 'Nazwa pracowni',
         electronicReferralFailureModal: {
            identifiedErrors: 'Zidentyfikowane błędy',
            print: 'Drukuj',
            referralSendFail: 'Nie udało się wysłać eSkierowania. Czy chcesz wydrukować skierowanie papierowe?',
         },
         electronicReferralSent: 'eSkierowanie zostało pomyślnie wysłane do P1. Kod {{code}}',
         electronicReferralSentNoCode: 'eSkierowanie zostało pomyślnie wysłane do P1. Kod: brak kodu dostępowego',
         examinationObjective: 'Cel badania (uzasadnienie)',
         examinationsAlreadyPerformed: 'Badania dotychczas wykonane',
         fetchingNFZDepartmentsList: 'Pobieranie listy oddziałów NFZ',
         insertAdditionalInformation: 'Uzupełnij dodatkowe informacje...',
         insertDiagnosticExamination: 'Wyszukaj kod lub nazwę procedury ICD-9, na którą kierujesz pacjenta…',
         insertDiagnosticLaboratoryType: 'Uzupełnij nazwę pracowni...',
         insertExaminationObjective: 'Uzupełnij cel badania...',
         insertExaminationsAlreadyPerformed: 'Uzupełnij dotychczas wykonane badania...',
         insertUnitNameAndAddress: 'Uzupełnij nazwę i adres jednostki, do której kierujesz...',
         missingDoctorCertificate: 'Brak ważnego certyfikatu lekarza.',
         missingHealthProviderCertificates:
            'Brak ważnych certyfikatów placówki lub rozbieżność numeru księgi rejestrowej z zapisanymi certyfikatami.',
         missingPatientNFZInfo: 'Do wysłania eSkierowania potrzebna jest informacja o oddziale NFZ pacjenta.',
         nfzDepartment: 'Oddział NFZ',
         procedure: {
            examinationType: 'Procedura',
            examinationTypeTooltip:
               'Wskaż procedurę ICD-9, której dotyczy skierowanie - czyli świadczenie, badanie lub leczenie, na które kierujesz pacjenta.',
            icd9ProcedureCode: 'ICD-9',
            icd9ProcedureName: 'Nazwa procedury',
            icd9ProceduresFetchError:
               'Nie udało się pobrać listy procedur z kopii roboczej. Uzupełnij ponownie pole "Badania".',
         },
         referralDraftSaved: 'Wersja robocza skierowania została zapisana.',
         referralFetchError: 'Nie udało się pobrać danych skierowania. Spróbuj ponownie.',
         referralToHospital: {
            chosenWardRequiresReferralToPsychiatricHospital:
               'Wybrany oddział wymaga uzupełnienia dedykowanego <psychiatricHospitalLink />',
            hospitalWard: 'Oddział',
            insertHospitalWardType: 'Uzupełnij typ oddziału...',
            referralToPsychiatricHospital: 'skierowania do szpitala psychiatrycznego',
         },
         referralToPsychiatricHospital: {
            actualGuardian: 'Osoba sprawująca opiekę faktyczną',
            address: {
               building: 'Nr domu',
               flat: 'Nr mieszkania',
               postcode: 'Kod pocztowy',
               street: 'Ulica',
               town: 'Miejscowość',
            },
            choose: 'Wybierz',
            enterDataOnce: 'Wprowadź dane jednorazowo',
            fillOtherJustifyingInformation:
               'Uzupełnij informacje uzasadniające potrzebę przyjęcia do szpitala psychiatrycznego, w tym dotyczące stosowania leczenia...',
            firstName: 'Imię',
            informationAboutPatient: 'Informacje o pacjencie',
            informationAboutPatientItems: {
               COMPLETELY_INCAPACITATED: 'Ubezwłasnowolnienie całkowite',
               NOT_INCAPACITATED: 'Nie jest ubezwłasnowolniony',
               NO_INFORMATION: 'Brak danych',
               PARTIALLY_INCAPACITATED: 'Ubezwłasnowolnienie częściowe',
            },
            lastName: 'Nazwisko',
            no: 'Nie',
            notApplicable: 'Nie dotyczy',
            otherJustifyingInformation:
               'Inne informacje uzasadniające potrzebę przyjęcia do szpitala psychiatrycznego, w tym dotyczące stosowania leczenia',
            patientExamination: 'Badanie pacjenta',
            statutoryRepresentative: 'Przedstawiciel ustawowy',
            statutoryRepresentativeConsent: 'Badanie wykonano za zgodą przedstawiciela ustawowego',
            twoPagePrintMessage: 'Skierowanie zostanie wydrukowane na dwóch stronach.',
            withConsent: 'Za zgodą',
            withoutConsent: 'Bez zgody',
            yes: 'Tak',
         },
         referralToRehabilitation: {
            fillIllnessesAlreadyPassed: 'Uzupełnij choroby przebyte i współistniejące oraz inne czynniki...',
            fillMedicalClinic: 'Uzupełnij nazwę poradni/działu...',
            illnessesAlreadyPassed: 'Choroby przebyte i współistniejące oraz inne czynniki',
            insertReferralObjective: 'Uzupełnij cel skierowania...',
            medicalClinic: 'Poradnia/Dział',
            referralObjective: 'Cel skierowania (uzasadnienie)',
         },
         referralToSpecialist: {
            clinic: 'Poradnia/Dział',
            fillClinic: 'Uzupełnij nazwę poradni/działu...',
            fillIllnessesAlreadyPassed: 'Uzupełnij choroby przebyte i współistniejące oraz inne czynniki...',
            illnessesAlreadyPassed: 'Choroby przebyte i współistniejące oraz inne czynniki',
            insertReferralObjective: 'Uzupełnij cel skierowania...',
            referralObjective: 'Cel skierowania (uzasadnienie)',
         },
         referralType: {
            ANALYTICAL_EXAMINATION: 'Skierowanie do laboratorium',
            DIAGNOSTIC_EXAMINATION: 'Skierowanie do pracowni diagnostycznej',
            DIAGNOSTIC_EXAMINATION_ELECTRONIC: 'eSkierowanie do pracowni diagnostycznej',
            HOSPITAL: 'Skierowanie do szpitala',
            HOSPITAL_ELECTRONIC: 'eSkierowanie do szpitala',
            PSYCHIATRIC_HOSPITAL: 'Skierowanie do szpitala psychiatrycznego',
            REHABILITATION: 'Skierowanie na rehabilitację',
            SPECIALIST: 'Skierowanie do specjalisty',
            SPECIALIST_ELECTRONIC: 'eSkierowanie do specjalisty',
         },
         save: 'Zapisz',
         searchOrInsertDiagnosticExamination: 'Wyszukaj lub wpisz badanie',
         sendElectronicReferral: 'Wyślij eSkierowanie',
         submit: 'Zatwierdź',
         submittingElectronicReferral: 'Wysyłanie eSkierowania',
         unitNameAndAddress: 'Nazwa i adres jednostki',
      },
   },
};

export const referralTranslationKeys = createScopedTranslationKeys(translations.pl, 'visit_referral');
export const analyticalExaminationTranslationKeys = referralTranslationKeys.analyticalExamination;
export const referralToSpecialistTranslationKeys = referralTranslationKeys.referralToSpecialist;
export const referralToPsychiatricHospitalTranslationKeys = referralTranslationKeys.referralToPsychiatricHospital;
export const referralIcd9ProcedureTranslationKeys = referralTranslationKeys.procedure;
